module.exports = __webpack_public_path__ + "static/media/thumbsUp2.8cf08838.png";